import React from 'react';
import UserInitialsItem from './UserInitialsItem';
import c from './userInitials.module.scss';

const UserInitialSection = ({
  index,
  selected,
  handleClose,
  handleFocus,
  handleKeyDown,
  innerRef,
  isMobile,
  children,
}) => {
  return (
    <div className={c.section}>
      {React.Children.map(children, (child, i) => {
        return child?.type === UserInitialsItem
          ? React.cloneElement(child, {
              index: index + i,
              selected: selected === i,
              handleClose,
              handleFocus,
              handleKeyDown,
              innerRef: (e) => (innerRef.current[index + i] = e),
              isMobile,
            })
          : child;
      })}
    </div>
  );
};

export default UserInitialSection;
